import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/lo-hp-new/hero-andy-lg@2x.webp")